import {useMergeControlState} from './merge-control-context'
import {DirectMergeInstructions} from './direct-merge/DirectMergeInstructions'
import {DisableAutoMergeInstructions} from './disable-auto-merge/DisableAutoMergeInstructions'
import {MergeQueueInstructions} from './add-to-merge-queue/MergeQueueInstructions'

export function Instructions() {
  const {mergeControlModel} = useMergeControlState()

  switch (mergeControlModel.type) {
    case 'disable-auto-merge':
      return <DisableAutoMergeInstructions />
    case 'merge-queue':
      return <MergeQueueInstructions />
    default:
      return <DirectMergeInstructions />
  }
}
